module.exports = __webpack_public_path__ + "img/spinning-rat-online.c048cc07.png";